module.exports = __webpack_public_path__ + "static/media/v32.40e1d497.mp4";